import {
  ActionIcon,
  createStyles,
  Flex,
  MantineTheme,
  Space,
  Stepper,
  Title,
} from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  IconArrowLeft,
  IconCheck,
  IconEye,
  IconFileText,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import DepositTopupStepOne from "./deposit-topup-step-1/DepositTopupStepOne";
import DepositTopupStepTwo from "./deposit-topup-step-2/DepositTopupStepTwo";
import DepositTopupStepThree from "./deposit-topup-step-3/DepositTopupStepThree";
import { STEP } from "./types.d";

interface Props {
  step: number;
  submitStepOne?: (
    beneficiaryAccountNo: string,
    actionAmount: string,
    availableBalance?: number,
  ) => void;
  submitStepTwo?: () => void;
  submitStepThree?: () => void;
  onBackStepOne?: () => void;
  loadingInit: boolean;
  loadingOtp: boolean;
}

const useStylesStepper = createStyles((theme: MantineTheme) => ({
  stepIcon: {
    "&[data-progress]": {
      borderWidth: 0,
      backgroundColor: theme.colors.primary[7],
      color: "#fff",
    },
    "&[data-completed]": {
      borderWidth: 0,
      backgroundColor: theme.colors.green[7],
      color: "#fff",
    },
  },
}));

const DepositTopupContainer: React.FC<Props> = ({
  step,
  submitStepOne,
  submitStepTwo,
  submitStepThree,
  onBackStepOne,
  loadingInit,
  loadingOtp,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { classes: classesStepper } = useStylesStepper();
  return (
    <>
      <Flex gap={4} justify="space-between" style={{ alignItems: "center" }}>
        <Flex align="center" gap={8}>
          <ActionIcon variant="transparent" onClick={() => navigate(-1)}>
            <IconArrowLeft />
          </ActionIcon>
          <Title
            order={4}
            sx={{
              margin: "0",
              paddingLeft: 10,
              backgroundClip: "padding-box, border-box",
              color: "inherit",
            }}
            fz={20}
          >
            {t("DEPOSIT_TOPUP_TITLE")}
          </Title>
        </Flex>
        {step !== STEP.STEP_3 && (
          <Stepper
            completedIcon={<IconCheck />}
            w="30%"
            active={step - 1}
            breakpoint="md"
            classNames={classesStepper}
            allowNextStepsSelect={false}
            mt={10}
          >
            <Stepper.Step
              icon={<IconFileText size="1.1rem" />}
              label={`${t("TOPUP_INFORMATION")}`}
            />
            <Stepper.Step
              icon={<IconEye size="1.1rem" />}
              label={`${t("CONFIRM")}`}
            />
          </Stepper>
        )}
      </Flex>
      <Space h={20} />
      {step === 1 && (
        <DepositTopupStepOne
          onSubmit={submitStepOne}
          loadingInit={loadingInit}
        />
      )}
      {step === 2 && (
        <DepositTopupStepTwo
          onSubmit={submitStepTwo}
          onBackStepOne={onBackStepOne}
          loadingOtp={loadingOtp}
        />
      )}
      {step === 3 && <DepositTopupStepThree onBackStepOne={onBackStepOne} />}
    </>
  );
};

export default DepositTopupContainer;
